import React, { useRef, useState } from 'react';
import './product-nearby-store-list-detail.scss';
import '../message/message.scss';
import { postMessageToClient } from '../chatservice/communicationService';

type ProductNearbyStoreListDetailProps = {
    nearbyStore: any,
    isHostDevice: any,
    toggleWidget: any
}

const formatStoreName = (storeName: any) => {
    const store = storeName.replaceAll("Dan Murphy's ", "");
    return store.charAt(0).toUpperCase() + store.slice(1).toLowerCase();
}

const getPackType = (product:any) =>{
    return product.availablePackTypes.sort((a: any, b: any) => a.UnitQty > b.UnitQty ? 1 : -1)[0];
}


const getInventoryStatus = (product: any, nearbyStore:any) => {
    const packTypeToShow = getPackType(product);
    if (packTypeToShow.Key === 'Bottle') {
        return `${nearbyStore?.storeAvailableQuantity} ${packTypeToShow.DisplayName} at ${formatStoreName(nearbyStore?.storeName)}`;
    }
    return `${Math.ceil(nearbyStore?.storeAvailableQuantity / packTypeToShow.UnitQty)} ${packTypeToShow.DisplayName} of ${packTypeToShow.UnitQty} at ${formatStoreName(nearbyStore?.storeName)}`;
}

const ProductNearbyStoreListDetail = ({ nearbyStore, toggleWidget, isHostDevice }: ProductNearbyStoreListDetailProps) => {

   let product = nearbyStore.product;
   let stockText = getInventoryStatus(product,nearbyStore);
   let [timeStr1,timeStr2] = nearbyStore.storeOpeningHours || ['',''];


    const onClickHandler = (e: any) => {


        const analyticsCall = {
            data: {
                linkName: `web:chatbot:product availability:find nearby:purchase from store:${nearbyStore.storeName}`,
                linkType: 'chatbot product availability',
            },
            methodHandler: "chatbotTriggerAdobeAnalytics"
        };
        postMessageToClient(analyticsCall);

        // init change url
        const objCall = {
            data: {
                prodDetailsUrl: product.productDetailsUrl,
                storeId: nearbyStore.storeNo,
                storeName: formatStoreName(nearbyStore.storeName),
                queryString: { i_cid: 'cbprodavail-findnearby' }
            },
            methodHandler: "chatbotInitChangeUrl"
        };

    //minimize widget
    toggleWidget(false);
    postMessageToClient(objCall);
}

return (
    <div className='store'>
        <div className='store__location'>
            <div className='store__title'>Dan Murphy's <span className='store__suburb'>{nearbyStore.suburb.toLowerCase()}</span></div>
            <div className='store__address'>{nearbyStore.addressLine1}</div>
            <div className='store__address'><span className='store__suburb'>{nearbyStore.suburb.toLowerCase()}</span> {nearbyStore.postcode}</div>
            <div className='store__address store__distance'>{nearbyStore.distance}km away</div>
            <p className='product__stock'>{stockText}</p>
        </div>

        <div className={'store__hours ' + (isHostDevice && 'store__hours--device')} >
            {<div className='store__date'>
                <span><b>{timeStr1}</b> {timeStr2 && '-'} {timeStr2}</span>
            </div> }
        </div>

        <div className="message__text--qr">
            <span className="message__text--click" onClick={onClickHandler}>Purchase from {nearbyStore.storeName}</span>
        </div>
    </div>
);
}

export {
    ProductNearbyStoreListDetail
}